import api from '../../services/service_question'

export default {
  data () {
    return {
      value: 'a',
      round_data: [],
      question_data: [],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      answers: [],
      is_disabled: true,
      allPoint: 0,
      fac_data: [],
      depart_data: [],
      campus_data: [],
      faculty_id_pri: 0,
      department_id_pri: 0,
      campus_id_pri: 0,
      comment: '',
      gender: 0,
      assessment_type: 0,
      answers_three: [],
      visible: true,
      username: '',
      password: '',
      email: ''
    }
  },
  methods: {
    checkDataSelect (answerChoiceId) {
      return this.answers.findIndex(x => x.answer_choice_id === answerChoiceId)
    },
    back () {
      window.location = this.base_url() + '/'
    },
    handleCancel () {
      this.visible = false
      this.back()
    },
    handleOk () {
      var obj = {
        username: this.username,
        password: this.password
      }
      this.$store.state.isLoading = true
      api.login(
        obj,
        result => {
          if (result.result === true) {
            this.email = result.data.mail
            this.visible = false
          } else {
            this.$notification['warning']({
              message: 'แจ้งเตือนแบบสอบถาม',
              description: result.data
            })
            this.$router.push('/')
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    handleChange (value) {
      this.faculty_id_pri = value
      this.getDepartment()
    },
    handleChangeCampus (value) {
      this.campus_id_pri = value
    },
    handleChangeDepart (value) {
      this.department_id_pri = value
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOptionCampus (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterOptionDepart (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onChange (e) {
      this.getQuestion(e.target.value)
    },
    getRound () {
      this.$store.state.isLoading = true
      api.getRoundDetail(
        this.$route.params.key,
        result => {
          if (result.result === true) {
            if (parseInt(result.data.is_open) !== 1) {
              this.$notification['warning']({
                message: 'แจ้งเตือนแบบสอบถาม',
                description: 'แบบสอบถามยังไม่เปิดให้บริการ !!'
              })
              this.$router.push('/')
            } else {
              this.round_data = result.data
              if (result.data.groups.length < 1) {
                this.$notification['warning']({
                  message: 'แจ้งเตือนแบบสอบถาม',
                  description: 'แบบสอบถามไม่สมบูรณ์ !!'
                })
                this.$router.push('/')
              } else {
                this.question_data = result.data.groups
              }
            }
          } else {
            this.$notification['warning']({
              message: 'แจ้งเตือนแบบสอบถาม',
              description: 'แบบสอบถามไม่สมบูรณ์ !!'
            })
            this.$router.push('/')
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    getCam () {
      this.$store.state.isLoading = true
      api.getCampus(
        result => {
          if (result.result === true) {
            this.campus_data = result.data
          } else {
            this.$notification['warning']({
              message: 'แจ้งเตือนแบบสอบถาม',
              description: 'แบบสอบถามไม่สมบูรณ์ !!'
            })
            this.$router.push('/')
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    getFac () {
      this.$store.state.isLoading = true
      api.getFaculty(
        result => {
          if (result.result === true) {
            this.fac_data = result.data
          } else {
            this.$notification['warning']({
              message: 'แจ้งเตือนแบบสอบถาม',
              description: 'แบบสอบถามไม่สมบูรณ์ !!'
            })
            this.$router.push('/')
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    getDepartment () {
      this.$store.state.isLoading = true
      api.getDepart(
        this.faculty_id_pri,
        result => {
          if (result.result === true) {
            this.depart_data = result.data
          } else {
            this.$notification['warning']({
              message: 'แจ้งเตือนแบบสอบถาม',
              description: 'แบบสอบถามไม่สมบูรณ์ !!'
            })
            this.$router.push('/')
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    addAnswerRadio ($questID, $choicID) {
      var check = this.answers
        .map(e => {
          return e.quest_id
        })
        .indexOf($questID)
      if (check < 0) {
        this.answers.push({
          quest_id: $questID,
          answer_choice_id: $choicID,
          answer_text: '',
          answer: ''
        })
      } else {
        this.answers[check].answer_text = ''
        this.answers[check].answer_choice_id = $choicID
      }
    },
    addAnswerText ($choicID, $text) {
      this.answers.forEach(val => {
        if (val['answer_choice_id'] === $choicID) {
          val['answer_text'] = $text
        }
      })
    },
    addAnswerCheck ($questID, $choicID) {
      var check = this.answers
        .map(e => {
          return e.answer_choice_id
        })
        .indexOf($choicID)
      if (check < 0) {
        this.answers.push({
          quest_id: $questID,
          answer_choice_id: $choicID,
          answer_text: '',
          answer: ''
        })
      } else {
        this.answers.splice(check, 1)
      }
    },
    addTable () {
      this.answers_three.push({
        title: '',
        detail: ''
      })
    },
    groupBy (array, f) {
      var groups = {}
      array.forEach(function (o) {
        var group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    },
    save () {
      var fac = this.faculty_id_pri
      if (this.campus_id_pri !== 0) {
        if (fac !== 0) {
          if (this.depart_data.length > 0) {
            if (this.department_id_pri !== 0) {
              var body = {
                key: this.$route.params.key,
                comment: this.comment,
                faculty_id_pri: this.faculty_id_pri,
                campus_id_pri: this.campus_id_pri,
                department_id_pri: this.department_id_pri,
                email: this.email,
                answers: this.answers,
                answer_three: this.answers_three
              }
              this.$store.state.isLoading = true
              api.addQuestionthree(body,
                result => {
                  if (result.result === true) {
                    this.$notification['success']({
                      message: 'แจ้งเตือนแบบสอบถาม',
                      description: result.data
                    })
                    location.reload()
                  } else {
                    this.$notification['warning']({
                      message: 'แจ้งเตือนแบบสอบถาม',
                      description: result.data
                    })
                  }
                  this.$store.state.isLoading = false
                },
                error => {
                  this.$store.state.isLoading = false
                  alert(JSON.stringify(error))
                }
              )
            } else {
              this.$refs.dep.focus()
              this.$notification['error']({
                message: 'ส่งคำตอบไม่สมบูรณ์',
                description: 'กรุณากรอกข้อมูลให้ครบถ้วน !!'
              })
            }
          } else {
            var data = {
              key: this.$route.params.key,
              comment: this.comment,
              faculty_id_pri: this.faculty_id_pri,
              campus_id_pri: this.campus_id_pri,
              department_id_pri: this.department_id_pri,
              email: this.email,
              answers: this.answers,
              answer_three: this.answers_three
            }
            this.$store.state.isLoading = true
            api.addQuestionthree(data,
              result => {
                if (result.result === true) {
                  this.$notification['success']({
                    message: 'แจ้งเตือนแบบสอบถาม',
                    description: result.data
                  })
                  location.reload()
                } else {
                  this.$notification['warning']({
                    message: 'แจ้งเตือนแบบสอบถาม',
                    description: result.data
                  })
                }
                this.$store.state.isLoading = false
              },
              error => {
                this.$store.state.isLoading = false
                alert(JSON.stringify(error))
              }
            )
          }
        } else {
          this.$refs.fac.focus()
          this.$notification['error']({
            message: 'ส่งคำตอบไม่สมบูรณ์',
            description: 'กรุณากรอกข้อมูลให้ครบถ้วน !!'
          })
        }
      } else {
        this.$refs.cam.focus()
        this.$notification['error']({
          message: 'ส่งคำตอบไม่สมบูรณ์',
          description: 'กรุณากรอกข้อมูลให้ครบถ้วน !!'
        })
      }
    }
  },
  mounted () {
    this.getFac()
    this.getCam()
    this.getRound()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/aritnet.js